import { render, staticRenderFns } from "./SearchPanelConfigurator.vue?vue&type=template&id=54f4c63b&"
import script from "./SearchPanelConfigurator.vue?vue&type=script&lang=js&"
export * from "./SearchPanelConfigurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports